import standardizedTestsData from './standardized-tests-content.json';
import type { StandardizedTestsContent } from './types';

export * from './types';

export const standardizedTestsContent = standardizedTestsData as StandardizedTestsContent;
